import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import metaPixelService from '../services/metaPixelService';

/**
 * Meta Pixel Tracker Component
 * This component initializes Meta Pixel on mount and tracks page views on route changes
 */
const MetaPixelTracker = () => {
  const location = useLocation();

  // Initialize Meta Pixel on component mount
  useEffect(() => {
    metaPixelService.init();
  }, []);

  // Track page views on route changes
  useEffect(() => {
    if (metaPixelService.isReady()) {
      // Get page name from pathname
      const pageName = location.pathname === '/' ? 'home' : location.pathname.slice(1).replace(/\//g, '_');
      metaPixelService.pageView(pageName);
    }
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
};

export default MetaPixelTracker;
